import React from "react";
import { Breakpoint } from "@mui/material/styles";
import styled from "@emotion/styled";
import { Drawer, DrawerProps } from "@mui/material";

export interface FullScreenDrawerProps {
  fullscreen: "true" | undefined;
  width?: Breakpoint;
}

const FullScreenDrawerComponent = styled(Drawer)`
  .MuiDrawer-paper {
    overflow-x: hidden;
  }
`;

const FullScreenDrawerContent = styled.div<FullScreenDrawerProps>`
  height: 100vh;
  width: ${(props) => `${props.fullscreen ? "100vw" : props.width ?? "375px"}`};
  display: flex;
  flex-direction: column;
`;

const FullScreenDrawer = ({
  children,
  ...props
}: FullScreenDrawerProps & DrawerProps) => {
  return (
    <FullScreenDrawerComponent {...props}>
      <FullScreenDrawerContent
        width={props.width}
        fullscreen={props.fullscreen}
      >
        {children}
      </FullScreenDrawerContent>
    </FullScreenDrawerComponent>
  );
};
export default FullScreenDrawer;
